// SPDX-License-Identifier: AGPL-3.0-or-later

import {CrownIcon} from '@phosphor-icons/react';
import type React from 'react';
import {forwardRef, useId} from 'react';

/** Community owner crown: solid gold with a lit top and a faint glow; same footprint as the old outline icon. */
export const OwnerCrownIcon = forwardRef<HTMLSpanElement, React.HTMLAttributes<HTMLSpanElement>>(function OwnerCrownIcon(
	{className, ...rest},
	ref,
) {
	const gradientId = `owner-crown-${useId().replace(/:/g, '')}`;
	return (
		// Single span root with forwarded ref/props so Tooltip (which clones its child) keeps working.
		<span ref={ref} {...rest} style={{display: 'inline-flex', ...rest.style}}>
			<svg width="0" height="0" aria-hidden style={{position: 'absolute', overflow: 'hidden'}}>
				<defs>
					<linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
						<stop offset="0" stopColor="#fff1a8" />
						<stop offset="0.45" stopColor="#ffc93c" />
						<stop offset="1" stopColor="#e08a00" />
					</linearGradient>
				</defs>
			</svg>
			<CrownIcon
				weight="fill"
				color={`url(#${gradientId})`}
				className={className}
				aria-hidden
				style={{
					filter: 'drop-shadow(0 0.5px 0 rgba(90, 50, 0, 0.6)) drop-shadow(0 0 2px rgba(255, 186, 40, 0.55))',
				}}
			/>
		</span>
	);
});
